<template>
    <Dialog v-model:open="opened">
        <DialogTrigger> <slot /> </DialogTrigger>
        <DialogContent>
            <div class="mt-2">
                <div id="stripe-connect-tax-settings"></div>
            </div>
            <DialogFooter>
                <button
                    type="button"
                    class="mt-3 inline-flex w-full justify-center rounded-md border border-iron-300 bg-white px-4 py-2 text-base font-medium text-iron-700 shadow-sm hover:bg-iron-50 focus:outline-none focus:ring-2 focus:ring-z-orange-500 focus:ring-offset-2 sm:ml-3 sm:mt-0 sm:w-auto sm:text-sm"
                    @click="closeModal"
                >
                    {{ $t("cancel") }}
                </button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogTrigger,
} from "@/components/ui/dialog";
import {computed, onMounted, ref, watch} from "vue";
import {loadConnectAndInitialize} from '@stripe/connect-js';
import axios from "axios";
import route from "ziggy-js";
import {usePage} from "@inertiajs/vue3";

const props = defineProps({
    integration: Object,
});

const emits = defineEmits(["update:modelValue"]);

const opened = ref(false);
const loading = ref(true);

const fetchClientSecret = async () => {
    const response = await axios.post(route('app.stripe-integrations.tax-settings.store', {
        'integration': props.integration.id,
    }));

    return response.data.data.client_secret;
}

const DEV_KEY =
    "pk_test_51JsOKHJ9tIQH9YIAUPeVLnYYZAb5B6Z8sFXDQpU0NxR1DYRvwqMvpjXG5yEoXAqOrl254F99OoK3gGlJi9dx1cDu00o96vbqi9";

const PROD_KEY =
    "pk_live_51JsOKHJ9tIQH9YIAlLi8C4w4S2lgXIqJKlfN2Im6kFNdzqOJH5ucC8gwlwztYLr8jW9b0pDhXasYX4BXUaaRQJjj009Rgl93Z1";

const STRIPE_KEY = import.meta.env.DEV ? DEV_KEY : PROD_KEY;
const page = usePage();
const locale = computed((): any => page.props.locale);

async function initStripeConnectTaxRegistration() {
    const stripeConnectInstance = await loadConnectAndInitialize({
        // This is your test publishable API key.
        publishableKey: STRIPE_KEY,
        fetchClientSecret: fetchClientSecret,
        locale: locale.value,
    });

    const taxRegistrations = stripeConnectInstance.create("tax-settings");
    const container = document.getElementById("stripe-connect-tax-settings");

    if (!container) {
        console.log("Container not found");
        return;
    }

    container.appendChild(taxRegistrations);
    loading.value = false;
}


watch(opened, (value) => {
    if (value) {
        initStripeConnectTaxRegistration();
    }
});

onMounted(async () => {

});


const closeModal = () => {
    opened.value = false;
};

</script>

<style></style>
